const breadcrumbLabels = {
  produtos: { label: "Produtos", clickable: true },
  usuarios: { label: "Usuários", clickable: true },
  videos: { label: "Vídeos", clickable: true },
  pdfgenerator: { label: "Gerador PDF", clickable: true },
  turmas: { label: "Turmas", clickable: true },
  testes: { label: "Testes", clickable: true },
  institucional: { label: "Institucional", clickable: true },
  empresas: { label: "Empresas", clickable: true },
  adicionar: { label: "Adicionar", clickable: true },
  atualizar: { label: "Atualizar", clickable: false },
  respostas: { label: "Respostas", clickable: true },
  adicionarTurma: { label: "Adicionar Turma", clickable: true },
  adicionarParticipante: { label: "Adicionar Participante", clickable: true },
  adicionarEmpresa: { label: "Adicionar Empresa", clickable: true },
  adicionarVideo: { label: "Adicionar Vídeo", clickable: true },
  adicionarProduto: { label: "Adicionar Produto", clickable: true },
  adicionarTeste: { label: "Adicionar Teste", clickable: true },
  adicionarUsuario: { label: "Adicionar Usuário", clickable: true },
  algoritmos: { label: "Algoritmos", clickable: true },
  adicionarAlgoritmo: { label: "Adicionar Algoritmo", clickable: true },
  ajuda: { label: "Ajuda", clickable: true },
  devolutivas: { label: "Devolutivas", clickable: true },
  adicionarDevolutivas: { label: "Adicionar Devolutivas", clickable: true },
  trilhas: { label: "Trilhas", clickable: true },
  adicionarTrilha: { label: "Adicionar Trilhas", clickable: true }
};

export default breadcrumbLabels;